/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Event_Group_RemovedInputs */



/**
* | output |
* | --- |
* | "Event Group to publish has been removed" |
*
* @param {Work_Order_Publish_Event_Group_RemovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_event_group_removed = /** @type {((inputs?: Work_Order_Publish_Event_Group_RemovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Event_Group_RemovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d’événements à publier a été supprimé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die zu veröffentlichende Ereignisgruppe wurde entfernt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo di eventi da pubblicare è stato rimosso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа мероприятий, готовящаяся к публикации, удалена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha eliminado el grupo de eventos para publicar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组已移除，无法发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開するイベントグループが削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन हेतु इवेंट ग्रुप को हटा दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos que iria publicar foi removido.")
	return /** @type {LocalizedString} */ ("Event Group to publish has been removed")
});